import React, { useEffect } from 'react';
import { Container, LinearProgress, Paper, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import moment from 'moment-timezone';
import { useNavigate, useParams } from 'react-router-dom';
import { useRecoilState, useSetRecoilState } from 'recoil';

import { driverAppealState, selectedAppealState } from '../../atoms/DriverAppealState';
import ListHeader from '../../components/ListHeader';
import Pagination from '../../components/Pagination';
import { listDriverAppeals } from '../../repositories/HttpRepository';
import { DRIVER_APPEALS_DATETIME_FORMAT } from '../../utils/dateUtil';
import Detail from './detail';
import SearchForm from './searchForm';
import useStyles from './styles';

const fields = [
  { id: 'region_code', numeric: false, disablePadding: true, label: 'Region' },
  { id: 'driver_id', numeric: false, disablePadding: true, label: 'Driver ID' },
  {
    id: 'driver_name',
    numeric: false,
    disablePadding: false,
    label: 'Driver Name',
    isDisableSort: true,
  },
  {
    id: 'reason',
    numeric: false,
    disablePadding: false,
    label: 'Reason',
    isDisableSort: true,
  },
  { id: 'status', numeric: false, disablePadding: false, label: 'Status' },
  { id: 'id', numeric: false, disablePadding: false, label: 'Left Days' },
  {
    id: 'created_ts',
    numeric: false,
    disablePadding: false,
    label: 'Created date',
  },
];

const DriverAppealList = () => {
  const [appeals, setAppeals] = useRecoilState(driverAppealState);
  const setSelected = useSetRecoilState(selectedAppealState);
  const { items, page, size, desc, order_by, total, isListing, search_text, appeal_status } = appeals;

  const navigate = useNavigate();
  const { classes } = useStyles();
  let { id } = useParams();

  const getList = (params) => {
    let queryParams = {
      size,
      page,
      search_text,
      appeal_status,
      order_by,
      desc,
    };
    if (params) queryParams = { ...queryParams, ...params };
    listDriverAppeals(queryParams).then((resp) => {
      if (resp.ok) {
        const data = resp.data;
        setAppeals({
          ...appeals,
          items: data.items,
          page: data.page,
          size: data.size,
          total: data.total,
        });
      }
    });
  };

  useEffect(() => {
    getList();
  }, [search_text, appeal_status, order_by, desc, page]);

  const handleChangePage = (event, newPage) => {
    setAppeals({ ...appeals, page: newPage });
  };

  const showDrivers = (e, courierId, courierObj) => {
    e.preventDefault();
  };

  const viewDetailAction = (item) => {
    setSelected(item);
    setTimeout(() => {
      navigate(`/driver-appeals/${item.id}`);
    }, 100);
  };

  const handleRequestSort = (event, property) => {
    const isDesc = order_by === property && desc;
    setAppeals({ ...appeals, desc: !isDesc, order_by: property });
  };

  const leftDays = (createdAt) => {
    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    const currentTime = Date.now();
    const diffDays = Math.round(Math.abs((currentTime - createdAt) / oneDay));
    const leftDays = 30 - diffDays;
    if (leftDays < 0) {
      return 'expired';
    }
    return leftDays;
  };

  return (
    <Container maxWidth={false} className={classes.root}>
      <SearchForm initValue={search_text} placeholder="Search for driver ID, driver name, reason content" />
      <Paper className={classes.paper}>
        <TableContainer>
          <Table className={classes.table} aria-labelledby="tableTitle" aria-label="enhanced table">
            <ListHeader fields={fields} desc={desc} orderBy={order_by} onRequestOrder={handleRequestSort} rowCount={items.length} />
            <TableBody>
              {items &&
                items.map((item, index) => {
                  const labelId = `dsp-table-item-${index}`;
                  return (
                    <TableRow hover tabIndex={-1} key={item.id} onClick={() => viewDetailAction(item)} sx={{ cursor: 'pointer' }}>
                      <TableCell component="th" scope="row">
                        {item.region_code || '-'}
                      </TableCell>
                      <TableCell component="th" id={labelId} scope="row">
                        {item.driver_id}
                      </TableCell>
                      <TableCell>{item.driver_name}</TableCell>
                      <TableCell>{item.reason.length < 100 ? item.reason : item.reason.substring(0, 100) + '...'}</TableCell>
                      <TableCell>{item.status}</TableCell>
                      <TableCell>{leftDays(item.created_ts)}</TableCell>
                      <TableCell>{moment.tz(item.created_ts, moment.tz.guess()).format(DRIVER_APPEALS_DATETIME_FORMAT)}</TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
          {isListing && <LinearProgress />}
        </TableContainer>
        <Pagination total={total} size={size} onChange={handleChangePage} forceUpdatePage={page - 1} />
      </Paper>

      {id && <Detail></Detail>}
    </Container>
  );
};
export default React.memo(DriverAppealList);
